import { createContext as e } from "react";
//#region src/context/AuthContext.ts
var t = e(null);
//#endregion
export { t as AuthContext };
